export interface CustomFieldsState {
	areaCustomFields: CustomFieldDto[],
	contactCustomFields: CustomFieldDto[],
	alarmCustomFields: CustomFieldDto[],
	serverCustomFields: CustomFieldDto[],
	deviceCustomFields: CustomFieldDto[],
	notificationTemplateCustomFields: CustomFieldDto[],
	totalAreaCustomFields: number,
	totalContactCustomFields: number,
	totalAlarmCustomFields: number,
	totalServerCustomFields: number,
	totalDeviceCustomFields: number,
	totalNotificationTemplateCustomFields: number
}

export interface CustomFieldValues {
	id: string;
	value: any;
}

export interface CustomFieldPriorityValue {
	id: string;
	value: any;
	title: string;
}

export interface CustomFieldValueAndSettings{
	value: CustomFieldValues,
	setting: CustomFieldDto
}

export interface CustomField {
	id: string;
	customFieldTableTypeId: number;
	customFieldTypeId: number;
	title: string;
	required: boolean;
	placeholder: string;
	order: number;
	options: CustomFieldOptions;
	externalIds?: string[];
	populatedByExtendedData?: boolean;
}

export interface CustomFieldDto extends CustomField {
}

export interface CustomFieldForDisplay extends CustomField {
	customFieldType: string;
}

export interface CustomFieldToggleCollapseState {
	id: number;
	isOpen: boolean;
}

export interface CustomFieldOptions {
	data?: string[];
	allowMultiple?: boolean;
	dataFromActionPlans?: DataFromActionPlans;
}

export enum CustomFieldTableTypes {
	Area = 1,
	Contact = 2,
	Alarm = 3,
	Server = 4,
	Device = 5,
	NotificationTemplate = 6,
}

export enum CustomFieldTypes {
	Text = 1,
	TextArea = 2,
	Number = 3,
	Checkbox = 4,
	Hyperlink = 5,
	Date = 6,
	Icon = 7,
	List = 8,
}

export enum CustomFieldExtendedDataTypes {
	ActionPlanResult = "ActionPlanResult",
}

export interface CustomFieldExtendedData {
	customField: CustomFieldDto;
	data: any;
}

export const CustomFieldExtendedDataSupportedTypes: CustomFieldTypes[] = [
	CustomFieldTypes.Text,
	CustomFieldTypes.TextArea,
	CustomFieldTypes.List,
];

export const CustomFieldExtendedDataIconDictionary= {
	[CustomFieldExtendedDataTypes.ActionPlanResult]: {
		icon: "fas fa-clipboard-list-check",
		title: "Set the value of this field from a completed Action Plan step.",
	},
}

export interface CustomFieldExtendedDataEmitValue {
	value: any;
	updateMessage: string;
}

export interface DataFromActionPlans {
	includeTaskTitle?: boolean;
	labelIds?: number[] | undefined | null;
}

export interface ActionPlanValue {
	value: string | null;
	label: string;
	taskText: string;
}

export interface ActionPlanValueOption extends ActionPlanValue {
	isCompletedTask: boolean;
}
